
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/wallet",
      function () {
        return require("private-next-pages/student/wallet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/wallet"])
      });
    }
  